module.exports = __webpack_public_path__ + "static/media/developIcon.ed253f20.svg";